import {useEffect, useState} from "react";
import ValuerAmendDropdownCard from "./valuer/ValuerAmendDropdownCard";
import GenericStrCard from "./GenericStrCard";
import check from "../assets/check_small.png"
import GenericIntCard from "./GenericIntCard";
import GenericCurrencyCard from "./GenericCurrencyCard";
import property_api from "../api/property"
import GenericDropdownCard from "./GenericDropdownCard";
import close from "../assets/close_small.png"
import ButtonLoadingWheel from "./ButtonLoadingWheel";
import val_api from "../api/valuation";
import {post} from "axios";


const ManualAddressPopup = (props) => {
    // Report Types
    const FINVISE = 1
    const RICS = 2

    const manual_evaluate = props.manual_evaluate
    const closeManualPopup = props.closeManualPopup
    const selectedType = props.selectedType

    // Dropdown Field Options
    const [reportTypes, setReportTypes] = useState([])
    const [reportPurposes, setReportPurposes] = useState([])
    const [propertyTypes, setPropertyTypes] = useState(["Flat/Maisonette", "Detached", "Semi-detached", "Terraced"])
    const [reportLength, setReportLength] = useState([]);

    // Required Fields
    const [saon, setSaon] = useState("")
    const [street, setStreet] = useState("")
    const [town, setTown] = useState("")
    const [county, setCounty] = useState("")
    const [postcode, setPostcode] = useState("")
    const [ref, setRef] = useState("")
    const [reportType, setReportType] = useState()
    const [reportPurpose, setReportPurpose] = useState()
    const [choosenReportLength, setChoosenReportLength] = useState(null);
    const reportCategory = props.reportCategory

    // Optional Fields
    const [showAdditionalInfo, setShowAdditionalInfo] = useState(false)
    const [bedrooms, setBedrooms] = useState("")
    const [bathrooms, setBathrooms] = useState("")
    const [livingRooms, setLivingRooms] = useState("")
    const [kitchens, setKitchens] = useState("")
    const [size, setSize] = useState("")
    const [extraDetails, setExtraDetails] = useState("")
    const [rent, setRent] = useState("")
    const [yearBuilt, setYearBuilt] = useState("")
    const [propertyType, setPropertyType] = useState("")
    const [uprn, setUprn] = useState("")

    const [processing, setProcessing] = useState(false)

    useEffect(() => {
        getValuationPurposes()
        getPropertyTypes()
    }, [])

    useEffect(() => {
        getValuationPropertyTypes()
    }, [reportCategory])

    useEffect(() => {
        // Report length options depend on which lengths have fee rules for this
        // organisation/property type, so only fetch once a property type is chosen.
        // Reset any previously chosen length too, since it may not be valid for the
        // new list.
        setChoosenReportLength(null)
        if (reportType && reportType.id) {
            getValuationReportLength()
        } else {
            setReportLength([])
        }
    }, [reportType])

    const getValuationPurposes = () => {
        let response = val_api.getValuationPurpose();
        response.then(response => {
            setReportPurposes(response.data.types)
        }).catch(err => console.log(err))
    }

    const getPropertyTypes = () => {
        let response = val_api.getFinvisePropertyTypes();
        response.then(response => {
            setPropertyTypes(response.data.types)
        }).catch(err => console.log(err))
    }

    const getValuationPropertyTypes = () => {
        if (!reportCategory) return
        let response = val_api.getValuationPropertyTypes(reportCategory.id);
        response.then(response => {
            setReportTypes(response.data.types)
        }).catch(err => console.log(err))
    }

    const getValuationReportLength = () => {
        if (props.reportLength && props.reportLength.length > 0) {
          setReportLength(props.reportLength)
          return
        }
        let organisationId = props.organisation ? props.organisation.id : null
        let response = val_api.getValuationReportLength(organisationId, reportType.id);
        response.then(response => {
            setReportLength(response.data.types)
        }).catch(err => console.log(err))
    }

    const FieldValidation = () => {
        let check
        // Do different checks for each type of report
        if (selectedType && selectedType.id === RICS)
            check = saon.trim() && street.trim() && town.trim() && postcode && reportType && reportType.id &&
                reportPurpose && reportPurpose.id && reportCategory && reportCategory.id
        else if (selectedType && selectedType.id === FINVISE)
            check = saon.trim() && street.trim() && postcode
        else check = false

        return check
    }

    const handleSubmit = () => {
        if (!FieldValidation() || processing) return
        setProcessing(true)
        submitAddress()
    }

    const submitAddress = () => {
        if (!FieldValidation()) return
        // Get different bodies for each type of report
        let body
        if (selectedType && selectedType.id === RICS) {
            body = {
                saon: saon,
                street: street,
                town: town,
                county: county.trim() || town, // Have town as fallback if no county, trim blank spaces to avoid sending just blank to county
                postcode: postcode.toLocaleUpperCase(),
                ref: ref,
                purpose: reportPurpose.id,
                report_category: reportCategory.id,
                report_length: choosenReportLength && choosenReportLength.id ? choosenReportLength.id : null,
                type: selectedType && selectedType.id,
                property_type: reportType.id,
                additional_info: {
                    selected: showAdditionalInfo,
                    bedrooms: parseInt(bedrooms),
                    bathrooms: parseInt(bathrooms),
                    livingRooms: parseInt(livingRooms),
                    kitchens: parseInt(kitchens),
                    size: parseInt(size),
                    extra_details: extraDetails,
                    rent: parseInt(rent)
                }
            }
            if (bedrooms === undefined || bedrooms === null || bedrooms === "") body.additional_info.bedrooms = "-"
            if (bathrooms === undefined || bathrooms === null || bathrooms === "") body.additional_info.bathrooms = "-"
            if (livingRooms === undefined || livingRooms === null || livingRooms === "") body.additional_info.living_rooms = "-"
            if (kitchens === undefined || kitchens === null || kitchens === "") body.additional_info.kitchens = "-"
            if (size === undefined || size === null || size === "") body.additional_info.size = 0
            if (extraDetails === undefined || extraDetails === null) body.additional_info.extra_details = ""
            if (rent === undefined || rent === null || rent === "") body.additional_info.rent = 0
        }
        else if (selectedType && selectedType.id === FINVISE) {
            body = {
                saon: saon,
                street: street,
                town: town.trim() || "",
                county: county.trim() || "",
                postcode: postcode.toLocaleUpperCase(),
                type: selectedType && selectedType.id,
                additional_info: {
                    "bedrooms": bedrooms && bedrooms ? bedrooms : "-",
                    "yearBuilt": yearBuilt && yearBuilt ? yearBuilt : "-",
                    "propertyType": propertyType && propertyType ? propertyType : "-",
                    "uprn": uprn && uprn ? uprn : "-",
                }
            }
        }
        
        let _addr_str = saon + " " + street + ", " + town + ", " + county + ", " + postcode.toLocaleUpperCase()

        manual_evaluate(body, _addr_str)
        setProcessing(false)
        closeManualPopup(false)
    }

    return(
        <>
            <div className="page-mask dark"/>
            <div className="popup-holding-container">
                <div className="manual-address-popup-container">
                    <div className="manual-address-header-container">
                        <div className="manual-address-header">
                            Add manual address
                        </div>
                        <div className="manual-address-header-close link" onClick={() => closeManualPopup(false)}>
                            <img src={close} alt="X"/>
                        </div>
                    </div>
                    <div className="manual-adress-content-container" id="scrollbar2">
                        <div className="manual-address-locality-container">
                            <GenericStrCard title="Flat number, house number or name*" value={saon} setValue={setSaon} classname=""/>
                            <GenericStrCard title="Street name*" value={street} setValue={setStreet} classname=""/>
                        </div>
                        <div className="manual-address-locality-container">
                            <GenericStrCard title={selectedType && selectedType.id === RICS ? "Town*" : "Town"} value={town} setValue={setTown} classname=""/>
                            <GenericStrCard title="County" value={county} setValue={setCounty} classname=""/>
                            <div className="generic-string-card-container">
                                <div className="generic-string-card-header-container">
                                    <div className="generic-string-card-header">
                                        Postcode*
                                    </div>
                                </div>
                                <div className="generic-string-text-container">
                                    <input type="text" value={postcode} placeholder=""
                                           onChange={(ev) => setPostcode(ev.target.value)}/>
                                </div>
                            </div>
                        </div>
                        {selectedType && selectedType.id === RICS ?
                            <>
                                <GenericStrCard title="Reference no." value={ref} setValue={setRef} classname=" small"/>
                                <div className="manual-address-purpose-container">
                                    <GenericDropdownCard title={"Report purpose*"} default="Select purpose" value={reportPurpose}
                                                         options={reportPurposes} setValue={setReportPurpose} />
                                    <GenericDropdownCard title={"Type*"} default="Select type" value={reportType}
                                                         options={reportTypes} setValue={setReportType} />
                            {
                              props.allow_report_length_choose ? <GenericDropdownCard title={"Report length*"} default="Select report length" value={choosenReportLength}
                                                         options={reportLength} setValue={setChoosenReportLength}
                                                         disabled={!(reportType && reportType.id) || !(reportLength && reportLength.length > 0)} /> : <></>
                            }
                                </div>
                                <div className="manual-address-additional-info-container">
                                    <div className="manual-address-additional-info-checkbox-container link"
                                         onClick={() => setShowAdditionalInfo(!showAdditionalInfo)}>
                                        {showAdditionalInfo
                                            ? <img src={check} alt={"tick"} />
                                            :null
                                        }
                                    </div>
                                    <div className="manual-address-additional-info-text">
                                        I know additional information about this address
                                    </div>
                                </div>
                                {showAdditionalInfo ?
                                    <>
                                        <div className="manual-address-locality-container">
                                            <GenericIntCard title="Bedrooms" value={bedrooms} setValue={setBedrooms}/>
                                            <GenericIntCard title="Bathrooms" value={bathrooms} setValue={setBathrooms}/>
                                            <GenericIntCard title="Living rooms" value={livingRooms} setValue={setLivingRooms}/>
                                            <GenericIntCard title="Kitchens" value={kitchens} setValue={setKitchens}/>
                                            <GenericIntCard title="Sq ft" value={size} setValue={setSize} />
                                        </div>
                                        <div className="manual-address-comment">
                                            <div className="manual-address-comment-title">
                                                Details of any outbuildings or annexes, eg garages, garden shed or office
                                                <div className="manual-address-comment-title-counter">({extraDetails.length}/300)</div>
                                            </div>
                                            <div className="manual-address-comment-text">
                                                <textarea value={extraDetails} onChange={(ev) => {
                                                    if (ev.target.value.length > 300) return
                                                    setExtraDetails(ev.target.value)
                                                }}/>
                                            </div>
                                        </div>
                                        <GenericCurrencyCard title={"If tenanted, how much rent is tenant currently paying per month?"}
                                                             value={rent}
                                                             setValue={setRent} />
                                    </>
                                    :
                                    null
                                }
                            </>
                            :
                            (selectedType && selectedType.id === FINVISE ?
                                <>
                                    <div className="manual-address-finvise-additional-details-text-container">
                                        <div className="manual-address-finvise-details-title">
                                            Additional details
                                        </div>
                                        <div className="manual-address-finvise-details-description">
                                            These details are optional, but adding them helps us give you a more confident result.
                                        </div>
                                    </div>
                                    <div className="manual-address-finvise-additional-details-container">
                                        <div className="manual-address-finvise-additional-details-int-container">
                                            <GenericIntCard title="Bedrooms" value={bedrooms} setValue={setBedrooms}/>
                                            <GenericIntCard title="Year built" value={yearBuilt} setValue={setYearBuilt}/>
                                        </div>
                                        <GenericDropdownCard title={"Property type"} default="" value={propertyType}
                                                             options={propertyTypes} setValue={setPropertyType} />
                                        <GenericStrCard title="UPRN" value={uprn} setValue={setUprn} classname=""/>
                                    </div>
                                </>
                                :
                                null
                            )
                        }
                        <div className={FieldValidation() ? "manual-address-submit-button link" : "manual-address-submit-button disabled"} onClick={handleSubmit}>
                            {processing
                                ? <ButtonLoadingWheel show={processing && processing}/>
                                : (selectedType && selectedType.id === RICS ? "Get RICS Regulated Valuation Report"
                                    : selectedType && selectedType.id === FINVISE ? "Get FINVISE Valuation Report"
                                        : "Get Report")
                            }
                        </div>
                        <div className="manual-address-footer">
                            *Indicates mandatory field
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManualAddressPopup
